export const BASE_URL = 'https://dog.ceo/api';
